import ModalHeader from 'features/shared/components/modal/ModalHeader';
import React from 'react'
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ContactDTO from '../dtos/ContactDTO';
import { ContactType } from '../enums/contactType';
import ContactsList from './ContactsList';

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  contacts: ContactDTO[];
  contactTypes: ContactType[];
  enableEditContact?: boolean;
  paginationRender?: () => JSX.Element;
}

const ContactsDialog = ({ show, setShow, contacts, contactTypes, enableEditContact, paginationRender }: Props) => {
  // translations
  const tLabels = useTranslation("customer\\customer").t;
  const tTypes = useTranslation("customer\\enums\\contactType").t;
  
  // helpers
  const getTitle = (contactTypes: ContactType[]) => {
    if (contactTypes.length > 0) {
      let type = contactTypes[0];

      if (type == ContactType.Email)
        return tTypes(ContactType.Email);
      else if (type == ContactType.Mobile || type == ContactType.Phone)
        return `${tTypes(ContactType.Phone)}/${tTypes(ContactType.Mobile)}`;
      else if (type == ContactType.Fax || type == ContactType.Url)
        return `${tTypes(ContactType.Fax)}/${tTypes(ContactType.Url)}`;
      else if (type == ContactType.DataBox)
        return tTypes(ContactType.DataBox);
    }

    return "";
  }
  
  // handlers
  const closeDialogHandler = () => {
    setShow(false);
  };

  // sub-renders
  const renderPagination = () => { 
    if (paginationRender) {
      return paginationRender();
    }
  }

  // render
  return (
    <Modal show={show} onHide={closeDialogHandler} scrollable>
      <ModalHeader title={`${tLabels("contactsDialog.contacts")} - ${getTitle(contactTypes)}`} onCloseClick={closeDialogHandler} />
      <div className="modal-body p-0">
        <ContactsList 
          contacts={contacts}
          enableEditContact={enableEditContact}
        />
      </div>
      {renderPagination()}
    </Modal>
  );
}

export default ContactsDialog
